var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPriceFullIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8055 14.0714C25.8055 18.3824 22.3107 21.8772 17.9996 21.8772C13.6886 21.8772 10.1938 18.3824 10.1938 14.0714C10.1938 9.76033 13.6886 6.26554 17.9996 6.26554C22.3107 6.26554 25.8055 9.76033 25.8055 14.0714Z",
    stroke: "#3C3C3C",
    strokeWidth: 1.05263
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 23.7547C19.9984 23.7547 21.8565 23.1438 23.4001 22.103C25.8318 22.4519 27.8255 23.1357 29.2188 24.3581C30.5379 25.5155 31.3775 27.2083 31.4789 29.7344H4.52057C4.62205 27.2084 5.46181 25.5155 6.78103 24.3581C8.17446 23.1357 10.1683 22.4519 12.6 22.103C14.1431 23.1442 16.0013 23.7547 17.9998 23.7547Z",
    stroke: "#3C3C3C",
    strokeWidth: 1.05263
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceFullIcon);
export default __webpack_public_path__ + "static/media/price_full_icon.1f0747fc751108d5ac042079892aaa76.svg";
export { ForwardRef as ReactComponent };